import React from 'react';
import { FormattedMessage } from 'react-intl';
import _map from 'lodash/map';
import { PropTypes } from 'prop-types';

import OwnerDetails from './OwnerDetails';

import classes from '../ContactDetails.module.scss';

function getAdditionalNumbers(numbersUrl) {
  const numbersWindow = window.open(numbersUrl, 'AdditionalNumbers');

  // Check for falsy value for electron to avoid "Cannot read property 'focus' of undefined"
  if (numbersWindow) {
    numbersWindow.focus(); // if the window/tab is already open, it will receive the focus
  }
}

const ContactDetails = (props) => {
  const { contact, additionalNumbersURL, hideOwner, pstnNumbers } = props;
  if (!contact) {
    return null;
  }
  return (
    <React.Fragment>
      {contact.extension && [
        <dt key="extensionTitle">
          <FormattedMessage id="components.contactDetails.extension" defaultMessage="Extension" />
        </dt>,
        <dd key="contactExtension">
          {contact.extension}
        </dd>
      ]}
      {contact.pin && [
        <dt key="passcodeTitle">
          <FormattedMessage id="components.contactDetails.passcode" defaultMessage="Passcode" />
        </dt>,
        <dd key="passcodeData">
          {contact.pin}
        </dd>
      ]}
      {pstnNumbers && !!pstnNumbers.length &&
        <div>
          <dt>
            <FormattedMessage id="components.contactDetails.phone" defaultMessage="Phone" />
          </dt>
          {_map(pstnNumbers, (number, index) =>
            <dd
              className={classes.flexNumber}
              key={`contactNumber${index}`}
            >
              <span>{number.countryName}:</span><span>{number.phoneNumber}</span>
            </dd>
          )}
          {additionalNumbersURL &&
            <dd>
              <a
                onClick={() => { getAdditionalNumbers(additionalNumbersURL); }} data-testid='open-additional-numbers'
              >
                <FormattedMessage
                  id="components.contactDetails.additionalNumbers"
                  defaultMessage="Additional numbers"
                />
              </a>
            </dd>
          }
        </div>
      }
      {contact.sipUri && [
        <dt key="sipUriTitle">
          <FormattedMessage
            id="components.contactDetails.videoAddress"
            defaultMessage="Video address"
          />
        </dt>,
        <dd key="sipUriData">
          {contact.sipUri}
        </dd>
      ]}
      {!hideOwner && <OwnerDetails owner={contact.owner} />}
      {contact.moderator && [
        <dt key="moderatorTitle">
          <FormattedMessage id="components.contactDetails.moderator" defaultMessage="Moderator" />
        </dt>,
        <dd key="moderatorData">
          {contact.moderator.name}
        </dd>
      ]}
      {contact.lecturer && [
        <dt key="lecturerTitle">
          <FormattedMessage id="components.contactDetails.lecturer" defaultMessage="Lecturer" />
        </dt>,
        <dd key="lecturerData">
          {contact.lecturer.name}
        </dd>
      ]}
    </React.Fragment>
  );
};

ContactDetails.propTypes = {
  contact: PropTypes.object.isRequired,
  additionalNumbersURL: PropTypes.string,
  hideOwner: PropTypes.bool,
  pstnNumbers: PropTypes.array
};

export default ContactDetails;
